var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"py-3 px-3 mb-3"},[_c('div',{staticClass:"d-flex align-center justify-space-between mb-3"},[_c('h4',{staticClass:"text-uppercase"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_c('div',[_vm._v("\n      "+_vm._s(_vm.info)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }